<app-loading-spinner *ngIf="contactRequestService.loadingConstantContact"></app-loading-spinner>
<p-dialog header="Add to mailing list" [(visible)]="displayBrevoDialog" [modal]="true">
    <div *ngIf="contactRequestService.contactRequest && contactRequestService.isUnsubscribed">
        <p>
            email: {{contactRequestService.contactRequest.email}} is unsubscribed to newsletter.
        </p>
    </div>
    <div class="brevo-lists-container" *ngIf="!contactRequestService.isUnsubscribed">
        <div>
            <p-listbox [disabled]="listBoxDisabled" [options]="brevoLists"
                [(ngModel)]="contactRequestService.selectedContactList" optionLabel="name"
                (onClick)="selectBrevoList($event.option)"></p-listbox>
        </div>
        <div class="selected-lists-container">
            <div *ngFor="let list of targetBrevoLists" (click)="removeBrevoList(list)" class="brevo-list-item">
                {{list.name}}</div>
        </div>
    </div>
</p-dialog>
<p-dialog header="Server Error" [(visible)]="hasBrevoErrorMessage" [modal]="true">
    <div *ngIf="brevoErrorMessage">
        <p class="global-warning">
            {{brevoErrorMessage}}
        </p>
    </div>
</p-dialog>
<p-dialog
    *ngIf="contactRequestService.contactRequestForm && contactRequestService.contactRequestForm.value.school && contactRequestService.programmeInformationForm"
    header="Add URL for {{contactRequestService.contactRequestForm.value.school.name}}" [(visible)]="editProgrammeUrls"
    [modal]="true">
    <div *ngFor="let control of contactRequestService.programmeInformationForm.controls; index as i"
        [formGroup]="control | formGroup" class="programme-informations-grid">
        {{i+1}} {{control.value.language.name}} <input pInputText formControlName="url">
        <a [href]="control.value.url" target="_blank" class="icon-container">
            <i class="pi pi-arrow-right"></i>
        </a>
    </div>
    <p-button (onClick)="addProgrammeUrls()" label="Save"></p-button>
</p-dialog>
<p-confirmDialog header="Delete Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-tabMenu [model]="navigationItems" [activeItem]="activeItem"></p-tabMenu>
<app-loading-spinner *ngIf="!contactRequestService.contactRequest"></app-loading-spinner>
<div *ngIf="contactRequestService.contactRequest" class="main-container">
    <div class="left-container">
        <app-edit-contact-request #editComponent [requestId]="requestId" *ngIf="activeItemId == 1">
        </app-edit-contact-request>
        <app-create-contact-request-quotation #quotationComponent [requestId]="requestId" *ngIf="activeItemId == 2">
        </app-create-contact-request-quotation>
        <app-contact-request-quotations (cloneQuotationEvent)="copyQuotation($event)" [requestId]="requestId"
            *ngIf="activeItemId == 4"></app-contact-request-quotations>
    </div>
    <div [formGroup]="contactRequestService.requestForm"
        *ngIf="contactRequestService && contactRequestService.requestForm" class="right-container">
        <div class="actions-title-container">
            <h3 class="global-title">
                Actions
            </h3>
        </div>
        <div class="quotation-buttons-container" *ngIf="activeItemId == 2">
            <p-button label="Submit" (onClick)="quotationComponent.createQuotation()" [style]="{'width':'224px'}">
            </p-button>
            <p-button label="Save as template" (onClick)="quotationComponent.activateTemplateSavingDialog()"
                [style]="{'width':'224px'}">
            </p-button>
            <p-button label="Load templates" (onClick)="quotationComponent.getQuotationTemplates()"
                [style]="{'width':'224px'}"></p-button>
            <p-button label="Update selected template" [disabled]="!leadQuotationService.selectedQuotationTemplate"
                (onClick)="quotationComponent.updateSelectedQuotationTemplate()" [style]="{'width':'224px'}"></p-button>
        </div>
        <div class="buttons-container">
            <p-button
                [disabled]="contactRequestService.contactRequest.isDeleted || contactRequestService.isSendingRequest"
                [style]="{'width':'224px'}" label="Save Changes" (onClick)="updateRequest()" *ngIf="activeItemId == 1"
                styleClass="p-button-success"></p-button>
            <p-selectButton dataKey="id" [options]="contactRequestService.leadStatuses" optionLabel="name"
                formControlName="leadStatus" (onChange)="contactRequestService.updateLeadStatus($event.value)">
            </p-selectButton>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted" (onClick)="activateBrevoDialog()"
                label="Brevo List" [style]="{'width':'224px'}">
            </p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted"
                (onClick)="contactRequestService.deleteContact()" label="Delete" styleClass="p-button-danger"
                [style]="{'width':'224px'}"></p-button>
            <div class="right-category-container">
                <h3 class="global-title">
                    Contact
                </h3>
            </div>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted"
                (onClick)="editComponent.activateEmailDialog()" label="Send E-mail" [style]="{'width':'224px'}"
                *ngIf="activeItemId == 1">
            </p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted"
                (onClick)="editComponent.copyEmailToClipboard()" label="Copy E-mail" [style]="{'width':'224px'}"
                *ngIf="activeItemId == 1"></p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted" label="Open in Zoiper"
                [style]="{'width':'224px'}" (onClick)="editComponent.callPhoneNumber()"
                *ngIf="activeItemId == 1"></p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted"
                (onClick)="editComponent.copyToClipboard()" label="Copy Phone" [style]="{'width':'224px'}"
                *ngIf="activeItemId == 1">
            </p-button>
            <div class="right-category-container">
                <h3 class="global-title">
                    Links
                </h3>
            </div>
            <a *ngFor="let info of contactRequestService.programmeInformations" [href]="info.lviSiteUrl"
                target="_blank">
                <p-button [disabled]="contactRequestService.contactRequest.isDeleted" label="LV Webpage {{info.label}}"
                    [style]="{'width':'224px'}"></p-button>
            </a>
            <a *ngIf="contactRequestService.contactRequestForm.value.school && contactRequestService.contactRequestForm.value.school.googleSheetUrl"
                [href]="contactRequestService.contactRequestForm.value.school.googleSheetUrl" target="_blank">
                <p-button [disabled]="contactRequestService.contactRequest.isDeleted" icon="pi pi-dollar"
                    label="Programme fees" [style]="{'width':'224px'}"></p-button>
            </a>
            <a *ngIf="contactRequestService.contactRequestForm.value.school"
                routerLink="/management/edit-school/{{contactRequestService.contactRequestForm.value.school.id}}"
                target="_blank">
                <p-button [disabled]="contactRequestService.contactRequest.isDeleted" label="Partner File"
                    [style]="{'width':'224px'}"></p-button>
            </a>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted"
                *ngIf="contactRequestService.contactRequestForm.value.school" label="Add Partner URL"
                [style]="{'width':'224px'}" (onClick)="activateProgrammeUrlEditWindow()">
            </p-button>

        </div>
        <div class="assignment-container">
            <div class="counsellors-container">
                <h3 class="global-title">
                    Assign to
                </h3>
                <table *ngIf="contactRequestService.counsellors.length > 0">
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr formArrayName="usersInCharge" *ngFor="let user of usersFormArray; let i = index">
                        <td>
                            <p-checkbox [formControlName]="i" [binary]="true"
                                (onChange)="contactRequestService.updateRequest()">
                            </p-checkbox>
                        </td>
                        <td>
                            <p class="counsellor-name">
                                {{contactRequestService.counsellors[i].name | titlecase}}
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="agent-container">
            <h3 class="global-title">
                Agent
            </h3>
            <p-dropdown (onChange)="contactRequestService.updateAgent($event.value)"
                [options]="contactRequestService.salesAgents" optionLabel="name" formControlName="salesAgent">
            </p-dropdown>
        </div>
        <div class="metadata-container">
            <h3 class="global-title">
                Metadata
            </h3>
            <p>
                Received on: {{contactRequestService.contactRequest.created | date: 'dd/MM/yyyy'}}
            </p>
            <p>
                Time received: {{contactRequestService.contactRequest.created | date: 'HH:mm'}}
            </p>
        </div>
    </div>
</div>